import superagentPromise from "superagent-promise";
import _superagent from "superagent";
import configureStore from "../store/store";
import { logoutUser } from "../store/actions/actions";


const superagent = superagentPromise(_superagent, Promise);

const responseBody = (res) => res.body;

const REACT_APP_API_URL = window.__ENV && window.__ENV.apiURL;

const handleErrors = (err) => {
  if(err && err.status === 401){
    const store = configureStore();
    store.dispatch((logoutUser("Unauthorized/TokenExpired")));
  }
}

const requests = {
  post: (url, body) =>
    superagent
      .post(url, body)
      .set("Content-Type", "application/json")
      .on("error", handleErrors)
      .then(responseBody),
  postData: (url, body) =>
    superagent
      .post(url, body)
      .set("Content-Type", "application/json")
      .on("error", handleErrors)
      .then(responseBody),
  postWithoutToken: (url) =>
    superagent
      .post(url)
      // .set('Content-Type', 'application/json')
      // .set('Authorization', `Bearer ${token}`)
      .on('error', handleErrors)
      .then(responseBody),
  getWithToken: (url, token) =>
    superagent
      .get(url)
      .set("Content-Type", "application/json")
      .set("Authorization", `Bearer ${token}`)
      .on("error", handleErrors)
      .then(responseBody),
  postWithToken: (url, body, token) =>
    superagent
      .post(url, body)
      .set("Content-Type", "application/json")
      .set("Authorization", `Bearer ${token}`)
      .on("error", handleErrors)
      .then(responseBody),
  deleteWithToken: (url, token) =>
    superagent
      .del(url, token)
      .set("Content-Type", "application/json")
      .set("Authorization", `Bearer ${token}`)
      .on("error", handleErrors)
      .then(responseBody),
  putWithToken: (url, body, token) =>
    superagent
      .put(url, body, token)
      .set("Content-Type", "application/json")
      .set("Authorization", `Bearer ${token}`)
      .on("error", handleErrors)
      .then(responseBody),
  uploadWithToken: (url, data, token) =>
    superagent
      .post(url, data)
      .set("Authorization", `Bearer ${token}`)
      .on("error", handleErrors)
      .then(responseBody),
  uploadWithoutToken: (url, data, token) =>
        superagent
          .post(url, data)
          .set('Content-Type', 'multipart/form-data')
          .set('Authorization', `Bearer ${token}`)
          .on('error', handleErrors)
          .then(responseBody),
};

const Auth = {
  login: (username ,password) => {
    return requests.postData(`${REACT_APP_API_URL}/api/Auth/Auth`,JSON.stringify({
      UserName: username, 
      Password: password,
    }))
  },
  signup:(username,email,password,re_password)=>{
    return requests.postData(`${REACT_APP_API_URL}/api/user/CreateUser`,JSON.stringify({
      UserName: username,
      Email: email,
      Password:password,
      ConfirmPassword: re_password
    }))
  },
  enableAccount:(code)=>{
    return requests.getWithToken(`${REACT_APP_API_URL}/api/user/AccountActivation?code=${code}`);
  },
  forgotPassword: (email) => {
    return requests.postData(`${REACT_APP_API_URL}/api/user/ForgotPassword`, JSON.stringify({
      Email: email,
    }))
  },
  getEmailAddress: (code) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/api/user/AccountVerification?code=${code}`);
  },
  resetPassword:(data, email)=>{
    return requests.postData(`${REACT_APP_API_URL}/api/user/ResetPassword`,JSON.stringify({
      Email: email,
      Password: data.password,
      ConfirmPassword: data.confirmPassword
    }))
  },
  logout: (accessToken,email,actionType) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/api/user/logout?userId=${email}&actionType=${actionType}`,accessToken);
  },
  getRefreshToken:(accessToken) => {
    return requests.postWithoutToken(`${REACT_APP_API_URL}/api/refresh_token?token_id=${accessToken}`);
  },
  getProfile: (accessToken) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/api/user/profile`, accessToken);
  },

  editProfile: (accessToken, data) => {
    return requests.postWithToken(`${REACT_APP_API_URL}/api/user/EditProfile`,data,accessToken);
  },

};

const Events = {
  getPublishedEvents: (accessToken) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/odata/EventList?$orderby=orderno asc`, accessToken);
  },
   getEventsList : (accessToken) =>{
    return requests.getWithToken(
      `${REACT_APP_API_URL}/odata/GetEvents?$orderby=startDateTime desc`,accessToken
    );
  },
  createNewEvent : (accessToken, data) => {
    return requests.postWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolEvent/UpdateEvent`,data, accessToken);
  },
  publishEvent : (accessToken, id) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolEvent/PublishEvent?EventId=${id}`, accessToken);
  },
  uploadFile:  (accessToken, id, file) => {
    const formData = new FormData();
    // Append questionId and file
    formData.append('file',file);
    formData.append('questionId', id);
    return requests.uploadWithToken(`${REACT_APP_API_URL}/api/QuestionAnswer/UploadAnswer`,formData, accessToken);
  },
  AutoEvaluateVI: (accessToken,data) => {
    return requests.postWithToken(`${REACT_APP_API_URL}/api/QuestionAnswer/AutoEvaluateVI`,data, accessToken);
  },
  SaveTestcases: (accessToken,data) => {
    return requests.postWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolQuestion/SaveTestcases`,data, accessToken);
  },
  uploadAnswerVI:  (accessToken, id, file) => {
    const formData = new FormData();
    // Append questionId and file
    formData.append('file',file);
    formData.append('questionId', id);
    return requests.uploadWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolQuestion/UploadAnswerVI`,formData, accessToken);
  },
  evaluateTestCases: (accessToken, data) => {
    return requests.postWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolQuestion/EvaluateTestCase`,data, accessToken);
  },
  getQuestionsList: (accessToken, id) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/odata/QuestionList?EventId=${id}&$orderby=questionNo asc`, accessToken);
  },
  addQuestion: (accessToken, data) => {
    return requests.postWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolQuestion/UpdateQuestion`, data, accessToken);
  },
  getAddedQuestions: (accessToken, id) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/odata/GetQuestions?EventId=${id}&$orderby=questionNo asc`, accessToken);
  },
  eventData: (accessToken, id) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolEvent/EventData?EventId=${id}`,accessToken);
  },
  deleteEvent: (accessToken, id) => {
    return requests.deleteWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolEvent/DeleteEvent?EventId=${id}`, accessToken);
  },
  getQuestionData: (accessToken, id) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/api/QuestionAnswer/QuestionData?QuestionId=${id}`, accessToken);
  },
  submitAnswer: (accessToken, id, answer) => {
    return requests.postWithToken(`${REACT_APP_API_URL}/api/QuestionAnswer/SubmitAnswer`, {questionId: id, answer: answer}, accessToken);
  },
  reUpload: (accessToken, id) => {
    return requests.postWithToken(`${REACT_APP_API_URL}/api/QuestionAnswer/ReUpload?QuestionId=${id}`, null, accessToken)
  },
  getEditQuestionsDataManualEval: (accessToken, id) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolQuestion/GetQuestionDataManual?QuestionId=${id}`, accessToken);
  },
  getEditQuestionsDataAutoEval: (accessToken, id) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolQuestion/GetQuestionDataAutomatic?QuestionId=${id}`, accessToken);
  },
  deleteQuestion: (accessToken, id) => {
    return requests.deleteWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolQuestion/DeleteQuestion?QuestionId=${id}`, accessToken);
  },
  getOrganizersList: (accessToken, id) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/odata/GetOrganizers?EventId=${id}`, accessToken);
  },
  setSelectedOrganizer: (accessToken, data) => {
    return requests.postWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolEvent/AddEventOrganizer`,data, accessToken);
  },
  getEventUsers: (accessToken, data) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/odata/GetUsers?EventId=${data.eventId}&IsOrganizer=${data.isOrganizer}`, accessToken);
  },
  getEvaluatorsList: (accessToken, id) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/odata/GetEvaluators?EventId=${id}`, accessToken);
  },
  setSelectedEvaluator: (accessToken, data) => {
    return requests.postWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolEvent/AddEventEvaluator`,data, accessToken);
  },
  deleteOrganizer: (accessToken, data) => {
    return requests.deleteWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolEvent/RemoveEventOrganizer?EventId=${data.eventId}&UserId=${data.userId}`, accessToken);
  },
  deleteEvaluator: (accessToken, data) => {
    return requests.deleteWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolEvent/RemoveEventEvaluator?EventId=${data.eventId}&UserId=${data.userId}`, accessToken);
  },
  setConfigFile: (accessToken, file, id) => {
    const formData = new FormData();
    formData.append('file',file);
    formData.append('eventId', id);
    return requests.uploadWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolEvent/UploadConfigFile`, formData, accessToken);
  },
  calculateViPerformance: (accessToken, id) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/api/QuestionAnswer/CalculateViPerformance?questionId=${id}`, accessToken);
  }
};

const Users = {
  getUsersList : (accessToken) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/odata/UserList?$orderby=createdOn desc`,accessToken)
  },
  getRoleList : (accessToken) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/odata/RoleList`,accessToken)
  },
  editRole : (accessToken, data) => {
    return requests.postWithToken(`${REACT_APP_API_URL}/api/User/EditUser`, data, accessToken)
  }
};

const Leaderboard = {
  getEventsLeaderboardList : (accessToken, id, sortby) => {
    if(sortby === "timeTaken")
    {
      return requests.getWithToken(`${REACT_APP_API_URL}/odata/EventLeaderboardList?EventId=${id}&orderby=NoOfQuestionsCompleted desc,${sortby} asc`, accessToken);
    }
    else{
      return requests.getWithToken(`${REACT_APP_API_URL}/odata/EventLeaderboardList?EventId=${id}&orderby=${sortby} asc`, accessToken);
    }
    
  },

  getQuesLeaderboardList : (accessToken, eventid, quesid, sort, filter) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/odata/QuestionLeaderboardList?EventId=${eventid}&QuestionId=${quesid}&orderby=${sort} ${filter}`, accessToken);
  },

  getEditLeaderboardList : (accessToken, quesid) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/odata/GetLeaderboard?QuestionId=${quesid}&orderby=rank asc`, accessToken);
  },

  editLeaderboard:(accessToken, data) => {
    return requests.postWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolLeaderboard/EditLeaderboard`,data, accessToken);
  },

  getLeaderboardEventsList : (accessToken) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/odata/GetEventList`, accessToken);
  },
  getLeaderboardQuestionsList : (accessToken, id) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/odata/GetQuestionDataList?EventId=${id}&orderby=questionNo asc`, accessToken);
  },
  getDropdownQuestionsList : (accessToken, id) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/odata/QuestionList?EventId=${id}&orderby=questionNo asc`, accessToken);
  },
  setLockEditing : (accessToken, data) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolLeaderboard/Lock?UserId=${data.userId}&QuestionId=${data.questionId}`,accessToken);
  },
  setUnlockEditing : (accessToken, data) => {
    return requests.getWithToken(`${REACT_APP_API_URL}/api/MaintenanceToolLeaderboard/Unlock?UserId=${data.userId}&QuestionId=${data.questionId}`,accessToken);
  }
};

export default {
  Auth,
  Events,
  Users,
  Leaderboard
}